import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=6e65e576&scoped=true"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"
import style0 from "./OidcCallback.vue?vue&type=style&index=0&id=6e65e576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65e576",
  null
  
)

export default component.exports